<template>
<div class="flex justify-center text-center leading-none mt-6 sm:mt-8">
    <p> Discover your office move personality </p>
</div>
</template>

<script>
export default {

}
</script>
